import { useState } from 'react';
import { ClaimApi } from '../../api/ClaimApi';
import { useAuth0 } from '@auth0/auth0-react';
import { t } from 'i18next';
import {
    ApiFile,
    ClaimDocument,
    ClaimRequest,
    UploadedImage
} from '../common/CommonTypes';

type SaveResponse = {
    success: boolean;
    imageId: string;
    errorMessage: string;
};

export const useClaimDocumentsUpload = (
    claimRequest: Pick<ClaimRequest, 'claimRequestId' | 'productReference'>
) => {
    const { getAccessTokenSilently } = useAuth0();

    const [uploadedDocuments, setUploadedDocuments] = useState<UploadedImage[]>(
        []
    );
    const [saving, setSaving] = useState(false);
    const [saveErrorMessage, setSaveErrorMessage] = useState<string>(undefined);

    const saveFileSuccess = (response: SaveResponse) => {
        if (response.success === false) {
            console.log(`Save file error: ${response.errorMessage}`);
            console.log(saveErrorMessage);
        } else {
            console.log(`Image saved: ${response.imageId}`);
            console.log(saving);
        }
    };

    const saveFileFailure = () => {
        setSaving(false);
        setSaveErrorMessage(t('image_save_error'));
    };

    const onSave = (image, documentTypeId, documentTypeName): void => {
        const saveFiles = async () => {
            const file: ApiFile = {
                filename: image?.filename ?? '',
                filepath: image?.uploadedPath ?? '',
                filetype: image?.type ?? ''
            };

            const claimDocument: ClaimDocument = {
                policy: claimRequest.productReference,
                claimId: +claimRequest.claimRequestId,
                file: file,
                documentTypeId,
                documentTypeName
            };

            const token = await getAccessTokenSilently();

            new ClaimApi().saveClaimDocuments(
                claimDocument,
                token,
                saveFileSuccess,
                saveFileFailure
            );
        };

        if (image !== undefined) {
            setSaving(true);
            setSaveErrorMessage(undefined);
            saveFiles();
        }
    };

    const onDocumentUploaded = (
        documentIndex: number, // TODO: use smth more reliable than index
        documentTypeName: string,
        image: UploadedImage,
        documentTypeId?: number
    ) => {
        const updatedUploadedDocuments = uploadedDocuments.map((d, i) => {
            if (i === documentIndex) {
                return image;
            } else {
                return d;
            }
        });

        const typeId = documentTypeId ?? documentIndex + 1;

        onSave(image, typeId, documentTypeName);
        setUploadedDocuments(updatedUploadedDocuments);
    };

    return {
        uploadedDocuments,
        onDocumentUploaded,
        setUploadedDocuments
    };
};
